import { render, staticRenderFns } from "./SMEevents.vue?vue&type=template&id=6b501cf4&scoped=true&"
import script from "./SMEevents.vue?vue&type=script&lang=js&"
export * from "./SMEevents.vue?vue&type=script&lang=js&"
import style0 from "./SMEevents.vue?vue&type=style&index=0&id=6b501cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b501cf4",
  null
  
)

export default component.exports